"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.esToColumnType = void 0;

var _lodash = require("lodash");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var esToColumnType = {
  "boolean": 'boolean',
  "byte": 'number',
  date: 'date',
  "double": 'number',
  "float": 'number',
  half_float: 'number',
  id: 'string',
  integer: 'number',
  keyword: 'string',
  "long": 'number',
  object: 'string',
  scaled_float: 'number',
  string: 'string',
  text: 'string',
  unsigned_long: 'number'
};
exports.esToColumnType = esToColumnType;

var appendDot = function appendDot(x) {
  return x ? x + '.' : '';
};

var mappingToColumnsType = function mappingToColumnsType(properties) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return (0, _lodash.flattenDeep)(Object.entries(properties).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        field = _ref2[0],
        data = _ref2[1];

    return !data.properties ? {
      type: isList ? 'list' : esToColumnType[data.type],
      field: "".concat(appendDot(parent) + field)
    } : [mappingToColumnsType(data.properties, "".concat(appendDot(parent)).concat(data.type === 'nested' ? "".concat(appendDot(field), "hits.edges[0].node") : field), data.type === 'nested' || isList)].concat(_toConsumableArray(data.type === 'nested' ? [{
      type: 'number',
      field: "".concat(appendDot(parent)).concat(appendDot(field), "hits.total")
    }] : []));
  }));
};

var _default = mappingToColumnsType;
exports["default"] = _default;